module.exports = __webpack_public_path__ + "static/img/project04.7543378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project04.jpg
// module id = BI5q
// module chunks = 1